import { Column, ColumnType } from '@scale/compass-shared/types';
import {
  TASKS,
  TaskAdapterContext,
  TaskAdapterCardShared,
  type TaskAdapterSchemaType,
} from '@scale/genai-compass-shared/cards/tasks';
import { CompassCardUI } from '@scale/compass-ui/types';
import { faTasks } from '@fortawesome/pro-solid-svg-icons';
import TaskAdapterCardComponent from './TaskAdapterCardComponent';

/** Input columns for Task Adapter filtering. */
export const TASK_ADAPTER_INPUT_COLUMNS: Record<string, Column> = {
  reviewLevel: {
    id: 'reviewLevel',
    header: 'Review Level',
    type: ColumnType.TEXT,
  },
  claimed: {
    id: 'claimed',
    header: 'Claimed',
    type: ColumnType.BOOLEAN,
  },
  taskStatus: {
    id: 'taskStatus',
    header: 'Task Status',
    type: ColumnType.TEXT,
  },
  humanNodeStatus: {
    id: 'humanNodeStatus',
    header: 'Human Node Status',
    type: ColumnType.TEXT,
  },
  lastAttemptedAt: {
    id: 'lastAttemptedAt',
    header: 'Last Attempted At',
    type: ColumnType.DATE,
  },
  createdAt: {
    id: 'createdAt',
    header: 'Created At',
    type: ColumnType.DATE,
  },
  batchId: {
    id: 'batchId',
    header: 'Batch ID',
    type: ColumnType.TEXT,
  },
  specializations: {
    id: 'specializations',
    header: 'Specializations Routing',
    type: ColumnType.ARRAY,
  },
  workerSkillSpecializations: {
    id: 'workerSkillSpecializations',
    header: 'Worker Skill Routing',
    type: ColumnType.ARRAY,
  },
  languageCode: {
    id: 'languageCode',
    header: 'Language Code',
    type: ColumnType.TEXT,
  },
};

const defaultContext: TaskAdapterContext = {
  cardType: TASKS,
  projectId: '',
  filter: {
    operator: 'and',
    filtersOrFilterGroups: [
      {
        column: TASK_ADAPTER_INPUT_COLUMNS.reviewLevel,
        condition: 'is',
        term: '',
      },
    ],
  },
};

export const TaskAdapterCardInfo: CompassCardUI<TaskAdapterSchemaType> = {
  ...TaskAdapterCardShared,
  title: 'Get Tasks',
  icon: 'clipboard',
  toolTip: 'Fetch tasks for your project.',
  defaultContext,
  ownerTeam: 'Connectivity',
  component: TaskAdapterCardComponent,
  button: {
    icon: faTasks,
    title: 'Tasks',
  },
};
